/**
 * Step 3 sub — Meta Ads ready (confirmation + Continue).
 *
 * 2026-05-22 redesign: shell wrap + restrained confirmation styling.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

import { useAuth } from '@/lib/useAuth';
import { computeRailState } from '@/lib/onboardingState';
import { Button } from '@/components/ui/button';
import { OnboardingShell } from '@/components/onboarding/OnboardingShell';

export function OnboardingFacebookSetupPage() {
  const { me } = useAuth();
  const navigate = useNavigate();

  const pixelId = me?.facebook_pixel_id ?? null;

  useEffect(() => {
    if (me?.is_system_admin) return;
    if (me && !pixelId) {
      navigate('/onboarding/connect/facebook-pick', { replace: true });
    }
  }, [me, pixelId, navigate]);

  return (
    <OnboardingShell
      current={3}
      title="Meta Ads ready"
      subtitle="Your WhatsApp contact events will flow to your Meta dataset via the Conversions API."
      state={computeRailState(me ?? null)}
    >
      <div className="space-y-5">
        <div className="rounded-3xl bg-card shadow-card p-7 sm:p-9">
          <div className="flex items-start gap-4">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-green-100">
              <CheckCircle2 className="h-7 w-7 text-green-700" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-xl font-bold text-dark">Connected</h3>
              <p className="mt-2 text-base text-muted-foreground leading-relaxed">
                Dataset ID: <code className="font-mono">{pixelId ?? '…'}</code>
              </p>
              <p className="mt-3 text-xs text-muted-foreground">
                Lead, Qualified, and Purchase events will fire automatically as your contacts progress.
              </p>
            </div>
          </div>
        </div>

        <Button
          type="button"
          className="w-full rounded-full bg-brand text-white hover:bg-brand-dark py-3.5 text-base font-bold"
          onClick={() => navigate('/')}
        >
          Continue
        </Button>
      </div>
    </OnboardingShell>
  );
}
